// Sol menü ağacı + yetki süzgeci — TEK kaynak. Sidebar (şerit + panel) ve Header sayfa araması buradan beslenir.
// Düzen (25.10.2026, HubSpot gezinmesinden): Benim İşim · nesneler (CRM) · modüller · Raporlama / Otomasyon /
// Kitaplık tek yerde · Ayarlar yalnız dişliden (şeritte görünmez, /settings yolunda panel kendiliğinden açılır).
// ⚠️ Sayfa adresleri DEĞİŞMEZ — yalnız menüdeki yerleri; yer imleri ve bildirim bağlantıları kırılmaz.
// Onay sayfaları menüde değil: kuyruk Onay Merkezi'nde (Finans Onayları hub'da olmadığı için Finans'ta kalır;
// Masraf/Avans/İzin sayfaları ödeme, kesinti, canias tekrarı gibi onay dışı işleri taşıdığı için İK › Yönetim'de).
import {
  Undo2, ArrowRightLeft, LayoutDashboard, ShoppingCart, TrendingUp, TrendingDown, BarChart3, Map, UserCheck, ClipboardList, Target, FileCheck,
  Package, PackageSearch, Archive, Gauge, Scale, Wallet, CreditCard, Clock, Receipt, FileText, PiggyBank, Banknote,
  Landmark, Truck, ClipboardCheck, Building2, CalendarClock, CalendarCheck, CalendarDays, Users, UserPlus, Filter,
  Workflow, FileBarChart, BarChart2, GitCompare, UserCog, Shield, Database, Settings, CheckSquare, Server, Send,
  User as UserIcon, Lock, SlidersHorizontal, Layers, Briefcase, Zap, Sparkles, Smartphone, Bell, Inbox, Mail,
  PieChart, Percent, Factory, IdCard, FolderKanban, ShieldCheck, ShieldAlert, Calculator, MessageSquare, Ship,
  FolderOpen, RotateCcw, Fingerprint, History, MapPin, HandCoins, WalletCards, MapPinned, CalendarRange,
  MessageCircle, KeyRound, Linkedin, Instagram, PackageX, BookText, Scissors, MailPlus, ListChecks, Home,
  Megaphone, Library, LineChart, ShoppingBag, BadgeDollarSign, PackageCheck, FileSpreadsheet, Link2
} from 'lucide-react'
import { partnerPathAllowed } from '../../utils/loginSurface'

export const SETTINGS_GROUP_ID = 'settings'

export const NAV_STRUCTURE = [
  {
    id: 'mywork',
    label: 'Benim İşim',
    icon: Home,
    items: [
      { label: 'Ana Sayfa', path: '/dashboard', icon: LayoutDashboard, module: 'DASHBOARD' },
      // module YOK (bilerek): onay yetkisi yönetici zincirinden de gelir — modüle bağlamak gerçek onaylayıcıdan gizlerdi
      { label: 'Onay Merkezi', path: '/approvals', icon: CheckSquare },
      { label: 'Görevlerim', path: '/tasks/my', icon: ListChecks, module: 'TASKS.MY_TASKS' },
      { label: 'Panolar', path: '/tasks', icon: FolderKanban, anyModules: ['TASKS.BOARD', 'SALES.TASKS'] },
      { label: 'Belge Süreçlerim', path: '/automation/my-documents', icon: ClipboardList },
    ],
  },
  {
    id: 'crm',
    label: 'CRM',
    icon: Users,
    items: [
      { section: 'Kayıtlar' },
      { label: 'Şirketler', path: '/crm/companies', icon: Building2, module: 'CRM.COMPANIES' },
      { label: 'Kişiler', path: '/crm/contacts', icon: UserPlus, module: 'CRM.CONTACTS' },
      { label: 'Satış Fırsatları', path: '/crm/deals', icon: Filter, module: 'CRM.DEALS' },
      { label: 'Aday Cariler', path: '/crm/prospects', icon: MapPin, module: 'CRM.PROSPECTS', minScope: 'Team' },
      { label: 'Müşteri Talepleri', path: '/crm/customer-requests', icon: UserPlus, module: 'CRM.CUSTOMER_REQUESTS' },
      { label: 'Aktiviteler', path: '/crm/activities', icon: CalendarCheck, module: 'CRM.ACTIVITIES' },
      { section: 'Gelen kutuları' },
      { label: 'E-posta', path: '/crm/inbox', icon: Inbox, module: 'CRM.INBOX' },
      { label: 'WhatsApp', path: '/crm/whatsapp', icon: MessageCircle, module: 'CRM.WHATSAPP' },
    ],
  },
  {
    id: 'sales',
    label: 'Satış',
    icon: TrendingUp,
    items: [
      { section: 'Belgeler' },
      { label: 'Teklifler', path: '/quotes', icon: FileText, module: 'SALES.QUOTATIONS' },
      { label: 'Siparişler', path: '/sales/orders', icon: ClipboardList, module: 'SALES.ORDERS' },
      { label: 'Açık Siparişler', path: '/sales/open-orders', icon: PackageSearch, module: 'SALES.ORDERS' },
      { label: 'Faturalar', path: '/sales/invoices', icon: Receipt, module: 'SALES.ORDERS' },
      { label: 'İade Talepleri', path: '/returns', icon: RotateCcw, module: 'SALES.RETURNS' },
      { label: 'İş Ortağı Siparişleri', path: '/partners/orders', icon: ShoppingBag, roles: ['ADMIN', 'GM', 'SALES_MGR', 'WH_MGR'] },
      { section: 'Satış araçları' },
      { label: 'Takip Dizileri', path: '/crm/sequences', icon: Workflow, module: 'CRM.SEQUENCES' },
      { label: 'Toplantılar', path: '/crm/meetings', icon: CalendarDays, module: 'CRM.MEETINGS' },
      { label: 'Hedefler', path: '/sales/targets', icon: Target, module: 'SALES.TARGETS' },
    ],
  },
  {
    id: 'marketing',
    label: 'Pazarlama',
    icon: Megaphone,
    items: [
      { label: 'Pazarlama E-postası', path: '/marketing/email', icon: MailPlus, module: 'MARKETING.EMAIL' },
      { label: 'Listeler', path: '/marketing/lists', icon: ListChecks, module: 'MARKETING.EMAIL' },
      { label: 'LinkedIn', path: '/marketing/linkedin', icon: Linkedin, module: 'MARKETING.LINKEDIN' },
      { label: 'Instagram', path: '/marketing/instagram', icon: Instagram, module: 'MARKETING.INSTAGRAM' },
      { label: 'SEO & AI Görünürlüğü', path: '/marketing/seo', icon: LineChart, module: 'MARKETING.SEO' },
      { label: 'Google Ads', path: '/marketing/ads', icon: BadgeDollarSign, module: 'MARKETING.ADS' },
    ],
  },
  {
    id: 'stock',
    label: 'Stok & Sevk',
    icon: Package,
    items: [
      { section: 'Stok' },
      { label: 'Ürün Kataloğu', path: '/stock/products', icon: Package, module: 'STOCK.PRODUCTS' },
      { label: 'Stok Durumu', path: '/stock/status', icon: Package, module: 'STOCK.STATUS' },
      { label: 'Ürün Hareketleri', path: '/stock/movements', icon: History, module: 'STOCK.MOVEMENTS' },
      { section: 'Sevk' },
      { label: 'Sevk Bekleyen Siparişler', path: '/stock/pending', icon: PackageSearch, module: 'STOCK.PENDING' },
      { label: 'Sipariş Takip', path: '/stock/order-tracking', icon: ListChecks, anyModules: ['SALES.ORDER_SUPPLY', 'SALES.ORDERS', 'STOCK.PENDING', 'PURCHASE.RESERVATIONS'] },
      { label: 'Mal Kabul', path: '/stock/receipts', icon: PackageCheck, module: 'STOCK.STATUS' },
      { label: 'Tedarikçiye İade', path: '/stock/vendor-returns', icon: Undo2, module: 'STOCK.STATUS' },
      { label: 'Depo Transferi', path: '/stock/transfers', icon: ArrowRightLeft, module: 'STOCK.STATUS' },
      { label: 'İade Girişi', path: '/stock/customer-returns', icon: RotateCcw, module: 'STOCK.STATUS' },
      { label: 'Bekleyen İrsaliyeler', path: '/delivery/pending', icon: PackageSearch, module: 'STOCK.STATUS' },
      { label: 'Kesilen İrsaliyeler', path: '/delivery/issued', icon: FileCheck, module: 'STOCK.STATUS' },
      { label: 'Tüm İrsaliyeler', path: '/sales/deliveries', icon: Truck, module: 'SALES.DELIVERIES' },
    ],
  },
  {
    id: 'purchase',
    label: 'Satınalma',
    icon: ShoppingCart,
    items: [
      { label: 'Satınalma Siparişleri', path: '/purchase/orders', icon: ShoppingCart, module: 'PURCHASE.ORDERS' },
      { label: 'Tedarikçiler', path: '/purchase/suppliers', icon: Building2, module: 'PURCHASE.SUPPLIERS' },
      { label: 'Rezervasyonlar', path: '/purchase/reservations', icon: CalendarClock, module: 'PURCHASE.RESERVATIONS' },
      { section: 'Siemens' },
      { label: 'Siemens Planlama', path: '/purchase/siemens-forecast', icon: Sparkles, module: 'PURCHASE.ORDERS' },
      { label: 'Siemens Eşleştirme', path: '/purchase/siemens-sync', icon: GitCompare, module: 'PURCHASE.ORDERS' },
      { section: 'Fiyat' },
      { label: 'Fiyat Karşılaştırma', path: '/purchase/price-comparisons', icon: GitCompare, module: 'PURCHASE.PRICE_COMPARE' },
      { label: 'Geçmiş Alım Fiyatları', path: '/purchase/price-history', icon: History, module: 'PURCHASE.PRICE_HISTORY' },
      { label: 'AI Fiyat Analizi', path: '/purchase/ai-analysis', icon: Zap, module: 'PURCHASE.PRICE_COMPARE' },
      { label: 'İthalat Teklif Analizi', path: '/purchase/import-offer', icon: Ship, module: 'PURCHASE.IMPORT_ANALYSIS' },
    ],
  },
  {
    id: 'manufacturing',
    label: 'İmalat',
    icon: Factory,
    items: [
      { label: 'İş Panosu', path: '/manufacturing/jobs', icon: FolderKanban, module: 'MANUFACTURING.JOBS' },
      { label: 'Malzeme Eksikleri', path: '/manufacturing/materials', icon: PackageX, module: 'MANUFACTURING.JOBS' },
      { label: 'Reçeteler', path: '/manufacturing/bom', icon: Layers, module: 'MANUFACTURING.BOM' },
      { label: 'Üretim Emirleri', path: '/manufacturing/production', icon: Factory, module: 'MANUFACTURING.PRODUCTION' },
    ],
  },
  {
    id: 'finance',
    label: 'Finans',
    icon: Wallet,
    items: [
      { label: 'Finans Özeti', path: '/finance/summary', icon: Wallet, module: 'FINANCE.SUMMARY' },
      { label: 'AI CFO', path: '/finance/cfo', icon: Sparkles, module: 'FINANCE.AI_CFO' },
      { section: 'Alacak' },
      { label: 'Cari Hesaplar', path: '/finance/accounts', icon: CreditCard, module: 'FINANCE.ACCOUNTS' },
      { label: 'Alacaklar', path: '/finance/aging', icon: Clock, module: 'FINANCE.AGING' },
      { label: 'Ödeme Performansı', path: '/finance/payment-performance', icon: BarChart3, module: 'FINANCE.PAYMENT_PERF' },
      { label: 'Kredi Risk', path: '/finance/credit-risk', icon: Shield, module: 'FINANCE.CREDIT_RISK' },
      // canias kredi/risk onayı — Onay Merkezi'nde YOK, burada kalır
      { label: 'Finans Onayları', path: '/finance/approvals', icon: ClipboardCheck, module: 'FINANCE.APPROVALS' },
      { section: 'Borç & Nakit' },
      { label: 'Borçlar', path: '/finance/payables', icon: TrendingDown, module: 'FINANCE.PAYABLES' },
      { label: 'Nakit Akışı', path: '/finance/cashflow', icon: Banknote, module: 'FINANCE.CASHFLOW' },
      { label: 'Ödeme Takvimi', path: '/finance/payment-calendar', icon: CalendarClock, module: 'FINANCE.PAYMENT_CALENDAR' },
      { label: 'Ödeme Talepleri', path: '/finance/payment-requests', icon: HandCoins, module: 'FINANCE.PAYMENT_REQUESTS' },
      { label: 'Banka Pozisyonu', path: '/finance/banking', icon: Landmark, module: 'FINANCE.BANKING' },
      { label: 'Banka Ekstreleri (MT940)', path: '/finance/bank-statements', icon: Banknote, module: 'FINANCE.BANKING' },
      { section: 'Sonuç' },
      { label: 'Kâr/Zarar', path: '/finance/pnl', icon: PiggyBank, module: 'FINANCE.PNL' },
      { label: 'Gider Analizi', path: '/finance/expenses', icon: Receipt, module: 'FINANCE.EXPENSES' },
      { section: 'Muhasebe' },
      { label: 'Muhasebe Fişi', path: '/finance/vouchers', icon: FileText, module: 'FINANCE.VOUCHER' },
      { label: 'Finansal Eşleştirmeler', path: '/finance/matching', icon: Link2, module: 'FINANCE.MATCHING' },
      { label: 'Maliyet Tutarlama', path: '/finance/cost-reconciliation', icon: CheckSquare, module: 'FINANCE.COST_RECON' },
    ],
  },
  {
    id: 'hcm',
    label: 'İnsan Kaynakları',
    icon: IdCard,
    items: [
      { section: 'Benim' },
      { label: 'Masraflarım', path: '/hcm/expenses', icon: Receipt, module: 'HCM.EXPENSES' },
      { label: 'Avanslarım', path: '/hcm/advances', icon: HandCoins, module: 'HCM.ADVANCES' },
      { label: 'İzinlerim', path: '/hcm/leaves', icon: CalendarClock, module: 'HCM.LEAVES' },
      { label: 'Dış Görevler', path: '/hcm/duties', icon: MapPinned, module: 'HCM.DUTIES' },
      { label: 'Puantajım', path: '/hcm/timesheet', icon: CalendarRange, module: 'HCM.TIMESHEET' },
      { section: 'Yönetim' },
      { label: 'PDKS Takip', path: '/hcm/attendance', icon: Fingerprint, module: 'HCM.ATTENDANCE' },
      // onay kuyruğu Onay Merkezi'nde; bu sayfalar bakiye, canias tekrarı, ödeme, fiş, kesinti işini taşır
      { label: 'İzin Yönetimi', path: '/hcm/leave-approvals', icon: CalendarCheck, module: 'HCM.LEAVE_APPROVALS' },
      { label: 'Masraf İşlemleri', path: '/hcm/expense-approvals', icon: ClipboardCheck, module: 'HCM.EXPENSE_APPROVALS' },
      { label: 'Avans İşlemleri', path: '/hcm/advance-approvals', icon: WalletCards, module: 'HCM.ADVANCE_APPROVALS' },
    ],
  },
  {
    id: 'reports',
    label: 'Raporlama',
    icon: LineChart,
    items: [
      { section: 'Genel' },
      // module YOK: herkes kendi işini, yönetici ekibini görür (kapsam sunucuda)
      { label: 'Günlük Rapor', path: '/reports/daily', icon: ClipboardList },
      { label: 'Kârlılık', path: '/analysis/profitability', icon: BarChart2, module: 'ANALYSIS.PROFITABILITY' },
      { label: 'Satış & Kâr Trendi', path: '/analysis/trends', icon: TrendingUp, module: 'ANALYSIS.TRENDS' },
      { label: 'Dönem Karşılaştırma', path: '/analysis/comparison', icon: GitCompare, module: 'ANALYSIS.COMPARISON' },
      { section: 'Satış' },
      { label: 'Satış Özeti', path: '/sales/summary', icon: TrendingUp, module: 'SALES.SUMMARY' },
      { label: 'Satışçı Performansı', path: '/sales/by-person', icon: UserCheck, module: 'SALES.BY_PERSON' },
      { label: 'Görev Performansı', path: '/sales/performance', icon: BarChart2, module: 'SALES.PERFORMANCE' },
      { label: 'Ürün Analizi', path: '/sales/by-product', icon: BarChart3, module: 'SALES.BY_PRODUCT' },
      { label: 'Müşteri Analizi', path: '/sales/customers', icon: Users, module: 'SALES.CUSTOMERS' },
      { label: 'Satış Haritası', path: '/sales/map', icon: Map, module: 'SALES.MAP' },
      { label: 'CRM Raporları', path: '/crm/reports', icon: FileBarChart, module: 'CRM.REPORTS' },
      { section: 'Stok' },
      { label: 'Hareketsiz Stok', path: '/stock/idle', icon: Archive, module: 'STOCK.IDLE' },
      { label: 'Stok Optimizasyonu', path: '/stock/optimization', icon: Gauge, module: 'STOCK.OPTIMIZATION' },
      { label: 'Stok Değerleme', path: '/stock/valuation', icon: Scale, module: 'STOCK.VALUATION' },
      { label: 'Siemens Trend', path: '/stock/siemens-trend', icon: TrendingUp, module: 'STOCK.SIEMENS_TREND' },
      { label: 'Siemens Stok Dağılımı', path: '/stock/siemens-distribution', icon: PieChart, module: 'STOCK.SIEMENS_DISTRIBUTION' },
    ],
  },
  {
    id: 'automation',
    label: 'Otomasyon',
    icon: Zap,
    items: [
      { label: 'İş Akışları', path: '/automation/workflows', icon: Workflow, module: 'AUTOMATION.WORKFLOWS' },
      { label: 'Sipariş Risk Akışı', path: '/automation/order-risk', icon: ShieldAlert, module: 'SALES.ORDER_RISK' },
    ],
  },
  {
    id: 'library',
    label: 'Kitaplık',
    icon: Library,
    items: [
      { label: 'Mesaj Şablonları', path: '/crm/templates', icon: BookText },
      { label: 'Kısa Parçalar', path: '/crm/snippets', icon: Scissors },
      { label: 'Dosyalar', path: '/storage', icon: FolderOpen, module: 'STORAGE.FILES' },
    ],
  },
  {
    id: 'audit',
    label: 'İç Denetim',
    icon: ShieldCheck,
    items: [
      { label: 'Genel Bakış', path: '/audit', icon: LayoutDashboard, module: 'AUDIT.FINDINGS' },
      { label: 'Tüm Bulgular', path: '/audit/findings', icon: ShieldAlert, module: 'AUDIT.FINDINGS' },
      { label: 'Tüm Kurallar', path: '/audit/rules', icon: SlidersHorizontal, module: 'AUDIT.RULES' },
      { label: 'Denetim Paketi', path: '/audit/package', icon: FileSpreadsheet, module: 'AUDIT.ACCOUNTING' },
      { section: 'Denetçiler' },
      { label: 'Muhasebe Denetçisi', path: '/audit/agent/accounting', icon: Calculator, module: 'AUDIT.ACCOUNTING' },
      { label: 'Finans & Hazine', path: '/audit/agent/finance', icon: Landmark, module: 'AUDIT.FINANCE' },
      { label: 'Stok Denetçisi', path: '/audit/agent/stock', icon: Package, module: 'AUDIT.STOCK' },
      { label: 'Vergi Denetçisi', path: '/audit/agent/tax', icon: Receipt, module: 'AUDIT.TAX' },
      { label: 'Satış Denetçisi', path: '/audit/agent/sales', icon: TrendingUp, module: 'AUDIT.SALES' },
      { label: 'Satınalma Denetçisi', path: '/audit/agent/purchase', icon: ShoppingCart, module: 'AUDIT.PURCHASE' },
      { label: 'CRM Denetçisi', path: '/audit/agent/crm', icon: Users, module: 'AUDIT.CRM' },
    ],
  },
  {
    // İş ortağı yüzeyi (PARTNER rolü). İç kullanıcıda boş kalır → şeritte görünmez.
    id: 'partner',
    label: 'İş Ortağı',
    icon: Building2,
    items: [
      { label: 'Panel', path: '/partner', icon: LayoutDashboard, roles: ['PARTNER'] },
      { label: 'Ürün Kataloğu', path: '/partner/catalog', icon: Package, module: 'PARTNER.CATALOG', roles: ['PARTNER'] },
      { label: 'Sepetim', path: '/partner/cart', icon: ShoppingCart, module: 'PARTNER.CART', roles: ['PARTNER'] },
      { label: 'Siparişlerim', path: '/partner/orders', icon: ClipboardCheck, module: 'PARTNER.ORDERS', roles: ['PARTNER'] },
      { label: 'Sevkiyat Takibi', path: '/partner/shipments', icon: Truck, module: 'PARTNER.SHIPMENTS', roles: ['PARTNER'] },
      { label: 'Belgelerim', path: '/partner/invoices', icon: Receipt, module: 'PARTNER.INVOICES', roles: ['PARTNER'] },
      { label: 'Stok Listem', path: '/partner/stock', icon: Package, module: 'PARTNER.STOCK_OWN', roles: ['PARTNER'] },
      { label: 'Kullanıcılar', path: '/partner/users', icon: Users, roles: ['PARTNER'], partnerAdmin: true },
    ],
  },
  {
    // label yok → düz kısayol (okunmamış rozetiyle)
    id: 'chat',
    icon: MessageSquare,
    items: [
      { label: 'Sohbet', path: '/chat', icon: MessageSquare, module: 'CHAT.CHANNELS' },
      { label: 'Sohbet', path: '/partner/chat', icon: MessageSquare, roles: ['PARTNER'] },
    ],
  },
  {
    // Ayarlar — şeritte YOK; Header'daki dişliden açılır, /settings yolunda panel kendiliğinden açılır.
    id: SETTINGS_GROUP_ID,
    label: 'Ayarlar',
    icon: Settings,
    hiddenInRail: true,
    items: [
      { section: 'Hesabım' },
      { label: 'Profil', path: '/settings/profile', icon: UserIcon },
      { label: 'Güvenlik', path: '/settings/security', icon: Lock },
      { label: 'Bildirim Ayarları', path: '/settings/notifications', icon: Bell },

      { section: 'Kullanıcılar & Erişim' },
      { label: 'Kullanıcılar', path: '/settings/users', icon: Users, module: 'ADMIN.USERS' },
      { label: 'Roller', path: '/settings/roles', icon: Shield, module: 'ADMIN.ROLES' },
      { label: 'Üyelik Yönetimi', path: '/settings/members', icon: UserPlus, module: 'ADMIN.USERS' },
      { label: 'İş Ortakları', path: '/settings/partners', icon: Building2, module: 'ADMIN.USERS' },
      { label: 'Mobil Cihazlar', path: '/settings/data/devices', icon: Smartphone, module: 'ADMIN.SETTINGS' },
      { label: 'Bildirim Logları', path: '/settings/notifications/logs', icon: Bell, module: 'ADMIN.SETTINGS' },
      { label: 'API Anahtarları', path: '/settings/integrations/api-keys', icon: KeyRound, roles: ['ADMIN'] },

      { section: 'Entegrasyonlar' },
      { label: 'Mail Hesapları', path: '/settings/data/mail-accounts', icon: Mail },
      { label: 'Banka Hesapları', path: '/settings/data/banks', icon: Landmark, module: 'ADMIN.SETTINGS' },
      { label: 'WhatsApp', path: '/settings/integrations/whatsapp', icon: MessageCircle, module: 'CRM.WHATSAPP' },
      { label: 'LinkedIn', path: '/settings/integrations/linkedin', icon: Linkedin, module: 'MARKETING.LINKEDIN' },
      { label: 'Instagram', path: '/settings/integrations/instagram', icon: Instagram, module: 'MARKETING.INSTAGRAM' },
      { label: 'Brevo (E-posta)', path: '/settings/integrations/brevo', icon: Send, module: 'MARKETING.EMAIL' },

      { section: 'Satış & CRM' },
      { label: 'Portföy Atamaları', path: '/settings/portfolio/assignments', icon: Briefcase, roles: ['ADMIN', 'GM', 'SALES_MGR'] },
      { label: 'İzin & Vekil (Portföy)', path: '/settings/portfolio/leaves', icon: CalendarClock, roles: ['ADMIN', 'GM', 'SALES_MGR'] },
      { label: 'Satış Asistanları', path: '/settings/sales/assistants', icon: UserCog, roles: ['ADMIN', 'GM', 'SALES_MGR'] },
      { label: 'Pipeline Yönetimi', path: '/settings/objects/deals/pipelines', icon: Layers, module: 'ADMIN.SETTINGS' },
      { label: 'Alış Kuru Anlaşmaları', path: '/settings/sales/fx-terms', icon: Percent, roles: ['ADMIN', 'GM', 'FIN_MGR', 'SALES_MGR'] },
      { label: 'Teklif Ayarları', path: '/settings/quote', icon: FileText, module: 'ADMIN.SETTINGS' },
      { label: 'Teklif Şablonları', path: '/settings/quote/templates', icon: FileText, module: 'ADMIN.SETTINGS' },
      { label: 'Onay Kâr Baremleri', path: '/automation/approval-rules', icon: Percent, module: 'ADMIN.SETTINGS' },
      { label: 'Teklif Otomatik Onay Kuralları', path: '/settings/automation/quote-approvals', icon: CheckSquare, module: 'ADMIN.SETTINGS' },
      { label: 'İmzalar ve Metinler', path: '/settings/mail/text-library', icon: BookText },

      { section: 'Satınalma' },
      { label: 'Proje Kodları', path: '/settings/data/siemens/project-codes', icon: FolderKanban, module: 'PURCHASE.ORDERS' },
      { label: 'Siemens Vade Kuralları', path: '/settings/purchase/siemens-terms', icon: CalendarClock, module: 'PURCHASE.ORDERS' },

      { section: 'Siemens' },
      { label: 'Ürün Entegrasyonu', path: '/settings/data/siemens', icon: Package, module: 'STOCK.SIEMENS_MAPPING' },
      { label: 'PoS Raporlama', path: '/settings/data/siemens-pos', icon: Send, module: 'STOCK.SIEMENS_MAPPING' },
      { label: 'Sınıflandırma', path: '/settings/data/siemens/classification', icon: Layers, module: 'STOCK.SIEMENS_MAPPING' },
      { label: 'Seriler', path: '/settings/data/siemens/series', icon: Layers, module: 'STOCK.SIEMENS_MAPPING' },
      { label: 'Fiyat Grubu İskontosu', path: '/settings/data/siemens/price-groups', icon: Percent, module: 'STOCK.SIEMENS_MAPPING' },

      { section: 'Finans' },
      { label: 'Masraf Hesap Eşlemesi', path: '/settings/expense/accounts', icon: Receipt, roles: ['ADMIN', 'GM', 'FIN_MGR'] },

      { section: 'İmalat' },
      { label: 'Proje Onaylayıcıları', path: '/settings/manufacturing/approvers', icon: UserCheck, roles: ['ADMIN', 'GM'] },
      { label: 'Belge Şablonları', path: '/settings/manufacturing/doc-templates', icon: FileText, module: 'MANUFACTURING.BOM', minScope: 'All' },

      { section: 'İnsan Kaynakları' },
      { label: 'Çalışma Takvimi', path: '/settings/hcm/work-schedule', icon: CalendarRange, module: 'HCM.TIMESHEET', minScope: 'All' },
      { label: 'Personel Eşleştirme', path: '/settings/hcm/personnel', icon: UserCheck, roles: ['ADMIN', 'GM'] },

      { section: 'Yapay Zekâ' },
      { label: 'AI Yapılandırma', path: '/settings/data/ai', icon: Zap, module: 'ADMIN.SETTINGS' },
      { label: 'AI Hazır Sorular', path: '/settings/data/ai-questions', icon: Sparkles, module: 'ADMIN.SETTINGS' },
      { label: 'AI Kullanım & Harcama', path: '/settings/data/ai-usage', icon: FileBarChart, module: 'ADMIN.SETTINGS' },

      { section: 'Sistem' },
      { label: 'Genel', path: '/settings/general', icon: SlidersHorizontal, module: 'ADMIN.SETTINGS' },
      { label: 'ETL Yönetimi', path: '/settings/data/etl', icon: Database, module: 'ADMIN.ETL' },
      { label: 'SQL Bağlantı Ayarları', path: '/settings/data/db-connections', icon: Server, module: 'ADMIN.SETTINGS' },
    ],
  },
]

// Menüden kaldırılan ama adresi çalışan sayfalar (kuyruk Onay Merkezi'nde). Önceden favoriye
// eklenmişse Favoriler'de görünmeye devam etsin diye etiketleri burada durur; menüde ÇİZİLMEZ.
export const FAVORITE_ONLY_PAGES = [
  { label: 'Teklif Onayları', path: '/sales/approvals', icon: FileCheck, module: 'SALES.APPROVALS' },
  { label: 'Satınalma Onayları', path: '/purchase/approvals', icon: ClipboardCheck, module: 'PURCHASE.APPROVALS' },
  { label: 'Ürün Onayları', path: '/stock/product-approvals', icon: ClipboardCheck, module: 'STOCK.PRODUCT_APPROVALS' },
]

/** Yetki süzgeci — menü ve sayfa araması AYNI kuralı kullanır. Boş bölüm başlıkları atılır. */
export function filterNavItems(items = [], { hasPermission, userRole, partnerIsAdmin }) {
  const filtered = items.filter((it) => {
    if (it.section) return true
    if (it.roles && !it.roles.includes(userRole)) return false
    // PARTNER: yetkisi olsa bile guard'ın geçirmediği sayfa görünmez (rol varsayılanına sızan iç anahtarlar)
    if (userRole === 'PARTNER' && it.path && !partnerPathAllowed(it.path)) return false
    if (it.partnerAdmin && !partnerIsAdmin) return false
    if (it.roles && !it.module && !it.anyModules) return true
    if (it.anyModules) return it.anyModules.some((m) => hasPermission(m, 'View', 'Own'))
    return !it.module || hasPermission(it.module, 'View', it.minScope || 'Own')
  })
  const out = []
  for (let i = 0; i < filtered.length; i++) {
    const it = filtered[i]
    if (!it.section) { out.push(it); continue }
    const rest = filtered.slice(i + 1)
    const nextSec = rest.findIndex((x) => x.section)
    const between = nextSec === -1 ? rest : rest.slice(0, nextSec)
    if (between.some((x) => !x.section)) out.push(it)
  }
  return out
}

/** Header sayfa araması: görünen tüm sayfalar, "Grup › Bölüm › Sayfa" etiketiyle. Elle yazılmış liste YOK (bayatlamasın). */
export function searchablePages(ctx) {
  const out = []
  const seen = new Set()
  for (const g of NAV_STRUCTURE) {
    let sec = null
    for (const it of filterNavItems(g.items, ctx)) {
      if (it.section) { sec = it.section; continue }
      if (!it.path || seen.has(it.path)) continue
      seen.add(it.path)
      const trail = [g.label, sec].filter(Boolean)
      out.push({ label: it.label, path: it.path, group: trail.join(' › '),
                 search: `${it.label} ${trail.join(' ')}`.toLocaleLowerCase('tr') })
    }
  }
  return out
}
